// 連続スライド式ティッカーの実装
let currentIndex = 0;
let tickerTimeout = null;

// 設定
const TICKER_CONFIG = {
  initialDelay: 1000,    // 初期表示までの遅延時間（ミリ秒）
  displayDuration: 5000, // 中央での表示時間（ミリ秒）
  slideInDuration: 1000, // スライドイン時間（ミリ秒）
  slideSpeed: 50         // スライドアウト速度（px/秒）
};

function initializeTicker() {
  const tickerContainer = document.querySelector('.ticker');
  const tickerItems = document.querySelectorAll('.ticker li');

  if (tickerItems.length === 0) {
    return;
  }

  // 既存のタイムアウトをクリア
  if (tickerTimeout) {
    clearTimeout(tickerTimeout);
    tickerTimeout = null;
  }

  // コンテナの幅を取得
  const containerWidth = tickerContainer.offsetWidth;

  // 全ての要素をリセット(初期状態では非表示)
  tickerItems.forEach((item) => {
    item.style.display = 'none';
    item.style.left = `${containerWidth}px`;
    item.style.transition = 'none';
  });

  // 最初の要素からスタート
  currentIndex = 0;
  animateTickerItem(tickerItems, containerWidth);
}

function animateTickerItem(items, containerWidth) {
  if (items.length === 0) return;

  const item = items[currentIndex];

  // アニメーション開始時に表示
  item.style.display = 'block';
  const itemWidth = item.offsetWidth;

  // 初期位置(右端)
  item.style.left = `${containerWidth}px`;
  item.style.transition = 'none';

  // 少し遅延してアニメーション開始
  setTimeout(() => {
    // フェーズ1: 右から画面中央へ素早く移動
    item.style.transition = `left ${TICKER_CONFIG.slideInDuration / 1000}s ease-out`;
    item.style.left = '10px';

    // フェーズ2: 画面中央で停止
    setTimeout(() => {
      // フェーズ3: 画面左へ移動(要素の幅に応じた速度)
      const slideOutDuration = (itemWidth + 10) / TICKER_CONFIG.slideSpeed;
      item.style.transition = `left ${slideOutDuration}s linear`;
      item.style.left = `-${itemWidth}px`;

      // 次の要素へ
      tickerTimeout = setTimeout(() => {
        currentIndex = (currentIndex + 1) % items.length;
        animateTickerItem(items, containerWidth);
      }, (slideOutDuration + 0.5) * 1000); // スライドアウト完了後0.5秒待機
    }, TICKER_CONFIG.displayDuration + TICKER_CONFIG.slideInDuration);
  }, 50);
}

// DOMContentLoadedイベントで遅延して初期化
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initializeTicker, TICKER_CONFIG.initialDelay);
});
